import classNames from "classnames";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TabNav } from "../../components/tabNav";
import { BgWrapper } from "../../components/wrapper/bgWrapper";
import { Privacy } from "./docs/privacy";
import { Refund } from "./docs/refund";
import { Terms } from "./docs/terms";
import { Service } from "./docs/service";

type Policies = "Terms of Use" | "Privacy Policy" | "Refund Policy" | "Service Agreement";

export const LegalPage = ({ className = "" }: { className?: string }) => {
  const [tab, setTab] = useState<Policies>("Terms of Use");

  const { doc } = useParams<{ doc: string }>();

  const navigate = useNavigate();

  useEffect(() => {
    switch (doc ?? "terms-of-use") {
      case "terms-of-use":
        setTab("Terms of Use");
        break;
      case "privacy-policy":
        setTab("Privacy Policy");
        break;
      case "refund-policy":
        setTab("Refund Policy");
        break;
      case "service-agreement":
        setTab("Service Agreement");
        break;
      default:
        setTab("Terms of Use");
        break;
    }
  }, [doc]);

  return (
    <div className={className}>
      <div
        className={classNames(
          "mx-auto flex w-full max-w-[660px] flex-col gap-[48px]",
        )}
      >
        <div className="w-full text-center">
          <h1 className="font-fraunces text-[32px] tracking-[-0.04em] text-grey-950 md:text-[52px]">
            {tab}
          </h1>
          <p className="mt-3 text-sm text-grey-600">
            Last updated on (April 27, 2025)
          </p>
        </div>
        <div className="flex flex-col gap-[2px]">
          <BgWrapper className="!rounded-b-none !p-2">
            <TabNav
              variant="switcher"
              navs={[
                {
                  title: "Terms of Use",
                  to: "Terms of Use",
                  onClick: () => {
                    navigate("/legal/terms-of-use");
                  },
                },
                {
                  title: "Privacy Policy",
                  to: "Privacy Policy",
                  onClick: () => {
                    navigate("/legal/privacy-policy");
                  },
                },
                {
                  title: "Refund Policy",
                  to: "Refund Policy",
                  onClick: () => {
                    navigate("/legal/refund-policy");
                  },
                },
                {
                  title: "Service Agreement",
                  to: "Service Agreement",
                  onClick: () => {
                    navigate("/legal/service-agreement");
                  },
                },
              ]}
              activeTab={tab}
            />
          </BgWrapper>

          <BgWrapper className="!rounded-t-none !p-[24px] md:!p-[48px]">
            {tab === "Privacy Policy" && <Privacy />}
            {tab === "Terms of Use" && <Terms />}
            {tab === "Refund Policy" && <Refund />}
            {tab === "Service Agreement" && <Service />}
          </BgWrapper>
        </div>
      </div>
    </div>
  );
};
